<template>
  <div class="courseWrap">
    <div class="lintingOne">
      <span> <img src="@/assets/mylearing/xz/hengxian.svg" class="svgs" alt="" /></span>
      <span><img src="@/assets/mylearing/xz/xingxing.png" class="xingxing" alt="" /></span>
      <span style="width: 200px">我点亮的全部课程</span>
      <span> <img src="@/assets/mylearing/xz/xingxing.png" class="xingxing" alt="" /></span>
      <span> <img src="@/assets/mylearing/xz/hengxian.svg" class="svgs" alt="" /></span>
    </div>
    <div class="allCourseIco">
      <span><img src="@/assets/mylearing/xz/one.png" alt="" /></span>
      <span><img src="@/assets/mylearing/xz/two.png" alt="" /></span>
      <span><img src="@/assets/mylearing/xz/two.png" alt="" /></span>
      <span><img src="@/assets/mylearing/xz/two.png" alt="" /></span>
    </div>
    <div class="lintingOne">
      <span> <img src="@/assets/mylearing/xz/hengxian.svg" class="svgs" alt="" /></span>
      <span><img src="@/assets/mylearing/xz/xingxing.png" class="xingxing" alt="" /></span>
      <span style="width: 200px">我获得的全部勋章</span>
      <span> <img src="@/assets/mylearing/xz/xingxing.png" class="xingxing" alt="" /></span>
      <span> <img src="@/assets/mylearing/xz/hengxian.svg" class="svgs" alt="" /></span>
    </div>
    <div class="allMyIco">
      <div>
        <span><img src="@/assets/mylearing/xz/tree.png" alt="" /><i>学习100分钟</i></span>
        <span><img src="@/assets/mylearing/xz/tree.png" alt="" /> <i>学习200分钟</i></span>
        <span><img src="@/assets/mylearing/xz/tree.png" alt="" /> <i>学习500分钟</i></span>
        <span><img src="@/assets/mylearing/xz/tree.png" alt="" /> <i>学习1000分钟</i></span>
      </div>
      <div>
        <span><img src="@/assets/mylearing/xz/tree.png" alt="" /> <i>完成10个任务</i></span>
        <span><img src="@/assets/mylearing/xz/tree.png" alt="" /> <i>完成100个任务</i></span>
        <span><img src="@/assets/mylearing/xz/tree.png" alt="" /> <i>学完1门课程</i></span>
        <span><img src="@/assets/mylearing/xz/tree.png" alt="" /> <i>学完5门课程</i></span>
      </div>
    </div>
    <div class="lintingOne">
      <span> <img src="@/assets/mylearing/xz/hengxian.svg" class="svgs" alt="" /></span>
      <span><img src="@/assets/mylearing/xz/xingxing.png" class="xingxing" alt="" /></span>
      <span style="width: 200px">我获得的课程学习称号</span>
      <span> <img src="@/assets/mylearing/xz/xingxing.png" class="xingxing" alt="" /></span>
      <span> <img src="@/assets/mylearing/xz/hengxian.svg" class="svgs" alt="" /></span>
    </div>
    <div class="myCourseTitle">
      <div>
        <p>建筑电气施工技术</p>
        <img src="@/assets/mylearing/xz/hz.png" alt="">
         <span>学富五车</span>
      </div>
      <div>
 <p>建筑电气施工技术</p>
   <img src="@/assets/mylearing/xz/hz.png" alt="">
       <span>学富五车</span>
      </div>
      <div>
 <p>建筑电气施工技术</p>
   <img src="@/assets/mylearing/xz/hz.png" alt="">
       <span>学富五车</span>
      </div>
      <div>
 <p>建筑电气施工技术</p>
   <img src="@/assets/mylearing/xz/hz.png" alt="">
       <span>学富五车</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  // name:'learningCourses',学习课程
  data() {
    return {};
  },
};
</script>

<style scoped>
.courseWrap {
  width: 100%;
  height: auto;
  /* padding: 10px; */
  overflow: hidden;
  /* border: 1px solid gray; */
}

.openIcon {
  margin: 0 auto;
  width: 100%;
}
.lintingOne {
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
}
.lintingOne > span {
  margin: 0 30px;
}
.iconWraps {
  display: flex;
}

.svgs {
  width: 400px;
  height: 4px;
  background: #4caf50;
}
.xingxing {
  width: 50px;
}
.allCourseIco {
  display: flex;
  justify-content: space-around;
  align-items: center;
  margin: 40px 0;
}
.allCourseIco span {
  width: 60px;
  height: 60px;
}

/* .allMyIco{
      display: flex;
    justify-content: space-around;
    align-items: center;
    flex-wrap: wrap;
    margin: 40px 0;
}
.allMyIco span{
  width: 80px;
} */

.allMyIco{
    margin: 40px 0;
}
.allMyIco > div {
  display: flex;
  justify-content: space-between;
}
.allMyIco > div > span {
  text-align: center;
  width: 100px;
}
.allMyIco > div > span i {
  font-style: normal;
  font-size: 13px;
}
.myCourseTitle{
    display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}
.myCourseTitle>div{
  position: relative;
    width: 38%;
    height: 60px;
    border: 1px solid #5db461;
    box-shadow:2px 2px 8px 0 #a59b9b;
    border-radius: 24px;
    margin: 20px 20px;

}
.myCourseTitle>div>p{
  width: 50%;
  margin: 0px;
  line-height: 60px;
  font-size: 18px;
  font-weight: bold;
  color: #5db461;
  text-align: center;
  display: inline-block;
}
.myCourseTitle>div>img{
  position: absolute;
  width: 70px;
  width: 80px;
    top: -17px;
}
.myCourseTitle>div>span{
  margin-left: 25%;
   display: inline-block;
   font-size: 16px;
   width: 40px;
   vertical-align: middle;
}
</style>
